var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title is-1"},[_vm._v("Test3")]),_c('b-button',{on:{"click":_vm.test}},[_vm._v(" Show msg ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }